import { useEffect, useState } from 'react'
import { getRequest } from '/src/httpClient'

export const useProductInventory = (product, store, quantity = 1) => {
  const [results, setResults] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!product || !store) return
    const controller = new AbortController();

    (async () => {
      setIsLoading(true)
      setResults(await getRequest(
        `/api/inventory?p=${product}&s=${store}&q=${quantity}`,
        controller
      ))
      setIsLoading(false)
    })()

    return () => controller.abort()
  }, [product, store, quantity])

  return { results, isLoading }
}
